import React, { useState } from 'react'
import {
  Card,
  CardBody,
  Button,
  Table
} from "reactstrap"
const TransactionReceipt = (props) => {

  return (
    <>

      {/* <Card>
        <CardBody>
          <h5 className="card-title">Transaction Receipt</h5>
          <div className='d-flex justify-content-between align-items-center flex-wrap mt-3'>
            <div className='d-flex gap-2 flex-wrap'>
              <Button
                outline
                color='primary'
                className='px-4 d-flex gap-2 align-items-center text-nowrap'
              >
                <i className='bx bx-download' style={{ fontSize: "18px" }}></i>
                Download Fiat Receipt
              </Button>
              <Button
                outline
                color='primary'
                className='px-4 d-flex gap-2 align-items-center text-nowrap'
              >
                <i className='bx bx-download' style={{ fontSize: "18px" }}></i>
                Download Crypto Receipt
              </Button>
            </div>
          </div>
        </CardBody>
      </Card> */}

      <Card className="quick-view">
        <CardBody className='mb-0'>
          <Table className="table align-middle table-nowrap mb-0" bordered>
            <tbody>
              <tr>
                <td><h5 className="font-size-16 mb-0">Transaction Receipt</h5></td>
                <td>
                  <Button
                    outline
                    size='sm'
                    color='primary'
                    className='px-4 d-flex gap-2 align-items-center text-nowrap'
                  >
                    <i className='bx bx-download' style={{ fontSize: "16px" }}></i>
                    Download Receipt
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </CardBody>
      </Card>
    </>
  )
}

export default TransactionReceipt